/*  
 * @描叙: 基础配置参数1
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-01-19 14:42:58
 */

const config = {
    ROUTERMODE: "history",  //  路由模式
    // DEFAULT_FILE_PATH: `http://${window.location.hostname}:10080`,    //  静态文件域名
    // WEBSOCKET: `ws://${window.location.hostname}:10083/ws`,    //  websocket地址

    // 测试环境
    // DEFAULT_FILE_PATH: 'http://192.168.101.230:10080',  //  静态文件域名
    // WEBSOCKET: 'ws://192.168.101.230:10083/ws',
    
	// 正式环境
    DEFAULT_FILE_PATH: 'http://26cjn.com',
    WEBSOCKET: 'ws://26cjn.com:10083/ws',
    DEFAULT_API_PATH: "http://26cjn.com/",    //  线上请求根域名
    UPLOAD_URL: '/ucenter/v2/base/fileupload',
    THEMECOLOR: '#009bac',  //  导航选择颜色   蓝色：#409EFF  #009bac       #71e8bb
    SIDEBARBGCOLOR: 'rgb(41, 61, 110)',  //  左侧导航背景色  黑：#001529     藏青：#009bac
    BMAPKEY: "48H73uYEStQzDzOiWwzZs4fCV3aztWiq",    // 百度地图API Key

    TIMEOUT: 1000 * 60 * 60,  // 登录超时时间 30分钟
	// TIMEOUT: 1000 * 5,
}

export default config
